// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.
// import DropdownController from "./dropdown_controller";
import { application } from "./application";
import { registerNiiwinControllers } from "@niiwin/core";
registerNiiwinControllers(application);

import AddressAutocompleteController from "./address_autocomplete_controller";
import BasicSelectController from "./basic_select_controller";
import CountUpController from "./count_up_controller";
import FormsContentSectionsController from "./forms/content_sections_controller";
import FormsFilterrificFormController from "./forms/filterrific_form_controller";
import FormsSlugController from "./forms/slug_controller";
import FaIconSelectController from "./fa_icon_select_controller";
import GoogleMapController from "./google_map_controller";
import PagyController from "./pagy_controller";
import ParallaxController from "./parallax_controller";
import PicflowController from "./picflow_controller";
import PopoverController from "./popover_controller";
import TrixController from "./trix_controller";
import FormsSortableController from "./forms/sortable_controller";
import FormsNestedDuplicateController from "./forms/nested_duplicate_controller";
import FormsNestedSortableController from "./forms/nested_sortable_controller";
import FormsStatusPublishedAtController from "./forms/status_published_at_controller";
import UserbackController from "./userback_controller";
import VideoEmbedController from "./video_embed_controller";

application.register("address-autocomplete", AddressAutocompleteController);
application.register("basic-select", BasicSelectController);
application.register("count-up", CountUpController);
application.register("fa-icon-select", FaIconSelectController);
application.register("forms--content-sections", FormsContentSectionsController);
application.register("forms--filterrific-form", FormsFilterrificFormController);
application.register("forms--slug", FormsSlugController);
application.register("google-map", GoogleMapController);
application.register("pagy", PagyController);
application.register("parallax", ParallaxController);
application.register("picflow", PicflowController);
application.register("popover", PopoverController);
application.register("trix", TrixController);
application.register("forms--sortable", FormsSortableController);
application.register("forms--nested-duplicate", FormsNestedDuplicateController);
application.register("forms--nested-sortable", FormsNestedSortableController);
application.register(
  "forms--status-published-at",
  FormsStatusPublishedAtController,
);
application.register("userback", UserbackController);
application.register("video-embed", VideoEmbedController);
